import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent {
  @Input() fullScreen: boolean = false;
  @Input() loading: boolean = false;
  @Input() type:'string'|'icon'='icon'
  @Input() message?:string=''
}
